import React from "react";
import checkboxCss from "../../../css/agents/checkbox.module.css";
import PropTypes from "prop-types";
import { getSingleLabelFromOptions } from "../FilterValue";

class Radio extends React.PureComponent {
    handleRadioChange = (event) => {
        const target = event.target;
        const checked = target.checked;
        const value = target.value;

        let fieldValue = this.props.value;
        const { options } = this.props;

        if (checked) {
            fieldValue.value = value;
            fieldValue.label = getSingleLabelFromOptions(options, value);
        } else {
            fieldValue.value = null;
            fieldValue.label = "";
        }

        this.props.onChange(fieldValue);
    };

    render() {
        const { options, value, name } = this.props;

        return (
            <>
                {options.map((option, index) => (
                    <label className={checkboxCss.radio} key={index}>
                        {option[1]}
                        <input
                            name={name}
                            type="radio"
                            value={option[0]}
                            checked={value.value === option[0]}
                            onChange={this.handleRadioChange}
                        />
                        <span className={checkboxCss.checkmark} />
                    </label>
                ))}
            </>
        );
    }
}

Radio.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default Radio;
